import * as _ from "lodash";
import angular = require("angular");
import { ClientDetails } from "../../clients/models/clientDetailsModel";
import { AttributionRepo } from "../attribution/attribution.repo";
import {
  defaultPortfolioAttributionBenchmark,
  defaultPortfolioAttributionBenchmarkDto,
  defaultPortfolioAttributionBenchmarkFM,
  DialogData,
  PortfolioAttributionBenchmarkDto,
  PortfolioAttributionBenchmarkFM,
  PortfolioAttributionBenchmarkValues,
} from "../models/PortfolioAttributionBenchmarkDto ";
import moment = require("moment");
class BenchmarkAttributionController implements angular.IOnInit {
  public client: ClientDetails;

  public dialogData: DialogData;
  public portfolioAttributionBenchmarkDto: PortfolioAttributionBenchmarkDto =
    _.cloneDeep(defaultPortfolioAttributionBenchmarkDto);
  public isLoading: boolean = false;

  public currentBenchmarks: PortfolioAttributionBenchmarkFM = _.cloneDeep(
    defaultPortfolioAttributionBenchmarkFM
  );

  public currentTTM: PortfolioAttributionBenchmarkFM = _.cloneDeep(
    defaultPortfolioAttributionBenchmarkFM
  );
  public previousTTM: PortfolioAttributionBenchmarkFM = _.cloneDeep(
    defaultPortfolioAttributionBenchmarkFM
  );
  public attributionTotal: PortfolioAttributionBenchmarkFM = _.cloneDeep(
    defaultPortfolioAttributionBenchmarkFM
  );
  public attributionTotalAdjusted: PortfolioAttributionBenchmarkFM =
    _.cloneDeep(defaultPortfolioAttributionBenchmarkFM);
  public previousBenchmarks: PortfolioAttributionBenchmarkFM;

  /** @ngInject */
  constructor(
    private notifyjs,
    private $mdDialog: angular.material.IDialogService,
    private attributionRepo: AttributionRepo,
    private $rootScope: angular.IRootScopeService
  ) {}

  $onInit() {
    this.isLoading = true;
    this.getPortfolioAttributionBenchmarks();
  }
  public getPortfolioAttributionBenchmarks() {
    this.attributionRepo
      .getPortfolioAttributionBenchmarks(this.client.clientNumber)
      .then((res) => {
        let data = res.data as PortfolioAttributionBenchmarkDto;

        this.portfolioAttributionBenchmarkDto.current = data.current;
        this.portfolioAttributionBenchmarkDto.previous = data.previous;
        this.currentBenchmarks = data.current.portfolioAttributionBenchmarkFM;
        this.previousBenchmarks = data.previous.portfolioAttributionBenchmarkFM;
        this.currentTTM = data.currentTTM;
        this.previousTTM = data.previousTTM;
        this.attributionTotal = data.portfolioAttributionTotal;
        this.attributionTotalAdjusted = data.portfolioAttributionTotalAdjusted;
      })
      .catch((err) => {
        this.notifyjs(
          `Failed fetching attribution benchmarks for client: ${this.client.clientNumber}`
        );
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  $onChanges(changes) {
    console.log();
  }

  public formatDateForDisplay(
    attributionBenchmark: PortfolioAttributionBenchmarkValues
  ) {
    let currentDate = new Date();
    let date = moment(attributionBenchmark.dateCreated).toDate();

    let isCurrentMonth =
      currentDate.getFullYear() === date.getFullYear() &&
      currentDate.getMonth() === date.getMonth();

    if (isCurrentMonth) {
      return "Current Month";
    }
    const formattedDate = date
      .toLocaleDateString("en-US", {
        month: "long",
        year: "2-digit",
      })
      .replace(" ", "-");
    return formattedDate;
  }

  public editPortfolioAttributionBenchmark(
    portfolioAttributionBenchmarkValues: PortfolioAttributionBenchmarkValues,
    portfolioAttributionBenchmarkPercentage: PortfolioAttributionBenchmarkFM
  ) {
    const tempScope = this.$rootScope.$new(true) as any;

    portfolioAttributionBenchmarkValues.portfolioAttributionBenchmarkFmId =
      portfolioAttributionBenchmarkPercentage.id;

    this.dialogData = {
      client: this.client.clientNumber,
      addingANewBenchmarkEntry: true,
      portfolioAttributionBenchmark: portfolioAttributionBenchmarkValues,
    };
    tempScope.dialogData = this.dialogData;

    this.$mdDialog
      .show({
        template: `<benchmark-attribution-edit-dialog dialog-data="dialogData"></benchmark-attribution-edit-dialog>`,
        clickOutsideToClose: true,
        scope: tempScope,
      })
      .then((result) => {
        this.isLoading = true;
        this.getPortfolioAttributionBenchmarks();
      });
  }

  public addNewPortfolioAttributionBenchmark() {
    const tempScope = this.$rootScope.$new(true) as any;

    this.dialogData = {
      client: this.client.clientNumber,
      portfolioAttributionBenchmark: defaultPortfolioAttributionBenchmark,
      addingANewBenchmarkEntry: false,
    };

    tempScope.dialogData = this.dialogData;

    this.$mdDialog
      .show({
        template: `<benchmark-attribution-edit-dialog dialog-data="dialogData"></benchmark-attribution-edit-dialog>`,
        clickOutsideToClose: true,
        scope: tempScope,
      })
      .then((result) => {
        this.isLoading = true;
        this.getPortfolioAttributionBenchmarks();
      });
  }
}

export const benchmarkAttribution: angular.IComponentOptions = {
  template: require("./benchmarkAttribution.html"),
  controller: BenchmarkAttributionController,
  bindings: {
    client: "<",
  },
};



// WEBPACK FOOTER //
// ./src/app/portfolioadmin/benchmarkAttribution/benchmarkAttribution.ts